@if (showHistoricalWarning) {
  <div class="warnings padding-50">
    {{ 'orders.historicalFilingsAreOrdersThatOriginated' | transloco }}
  </div>
}
@if (showBasicWarning) {
  <div class="warnings padding-50">
    {{ 'orders.basicOrdersAreMeantForRegistrations' | transloco }}
  </div>
}